import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ChipComponent } from './chip.component';

@NgModule({
  declarations: [ChipComponent],
  imports: [CommonModule, IonicModule],
  exports: [ChipComponent],
})
export class ChipComponentModule {}
